import { Component, OnInit } from '@angular/core';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-rentals-deliveries-collections-configuration',
  templateUrl: './rentals-deliveries-collections-configuration.component.html',
  styleUrls: ['./rentals-deliveries-collections-configuration.component.scss']
})
export class RentalsDeliveriesCollectionsConfigurationComponent {
  public partnerID = this.helpersService.getPartnerId();

  public isWorkshop : boolean = false;
  public isRentals : boolean = true; //Need to rework this at some point, wanted to use the same screen for both but needed some changes making this difficult

  public loadingPartners = false;
  public linkedPartners: any[];
  public loadingAllLinkedPartners = false;
  public allLinkedPartners: any[];

  public loadingVehicleList = false;
  public vehicleList: any = [];
  public showVehicleConfig = false;

  public loadingCutOffRules = false;
  public cutOffRules: any = [];
  public showCutOffTimeConfig = false;

  public loadingDeliveryAreas = false;
  public deliveryAreas: any = [];
  public showDeliveryAreaConfig = false;

  public loadingDefaultSlots = false;
  public defaultSlots: any = [];
  public showDefaultSlotsConfig = false;

  public loadingOverrideSlots = false;
  public overrideSlots: any = [];
  public showOverrideSlotsConfig = false;

  public loadingUnavailableDates = false;
  public unavailableDates: any = [];
  public showUnavailableDatesConfig = false;

  public panelData: any = {};
  public countryData: any = {};

  public currencySymbol = '';
  public VATInclusive;

  constructor(
    private collectionsService: CollectionsV2Service,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) {}

  ngOnInit() {

    
    this.isRentals = true;
    

    this.countryData = this.helpersService.getCountryData();
    this.currencySymbol = this.helpersService.getPartnerData().CurrencySymbol;
    this.VATInclusive = this.helpersService.getPartnerData().VATInclusive;

    this.getAllLinkedPartners();
    this.getLinkedEnabledPartners();
    this.getVehicleList();
    this.getDeliveryAreas();
    //this.getCutOffRules();
    this.getDefaultSlots();
    this.getOverrideSlots();
    this.getUnavailableDates();
  }

  getAllLinkedPartners() {
    this.loadingAllLinkedPartners = true;
    this.collectionsService.getAllLinkedPartners(this.partnerID, this.isWorkshop ? "WORKSHOP": this.isRentals ? "RENTALS" : "").subscribe(
      (res) => {
        console.log(res);
        this.allLinkedPartners = res;
        this.loadingAllLinkedPartners = false;
      },
      (err) => {
        this.loadingAllLinkedPartners = false;
      },
    );
  }

  getLinkedEnabledPartners() {
    this.loadingPartners = true;
    this.collectionsService.getEnabledLinkedPartners(this.partnerID, this.isWorkshop ? "WORKSHOP": this.isRentals ? "RENTALS" : "").subscribe(
      (res) => {
        console.log(res);
        this.linkedPartners = res;
        this.loadingPartners = false;
      },
      (err) => {
        this.loadingPartners = false;
      },
    );
  }

  getVehicleList(showLoading = true) {
    setTimeout(() => (this.loadingVehicleList = showLoading));
    this.collectionsService.getVehicleList(this.partnerID).subscribe(
      (res) => {
        console.log(res);
        this.vehicleList = res;
        this.loadingVehicleList = false;
      },
      (err) => {
        this.loadingVehicleList = false;
      },
    );
  }

  // getCutOffRules(showLoading = true) {
  //   setTimeout(() => this.loadingCutOffRules = showLoading);
  //   this.collectionsService.getCutOffRules(this.partnerID).subscribe(res => {
  //     console.log(res);
  //     this.cutOffRules = res;
  //     this.loadingCutOffRules = false;
  //   }, err => {
  //     this.loadingCutOffRules = false;
  //   })
  // }
  getDeliveryAreas(showLoading = true) {
    setTimeout(() => (this.loadingDeliveryAreas = showLoading));
    this.collectionsService.getDeliveryAreas(this.partnerID).subscribe(
      (res) => {
        console.log(res);
        this.deliveryAreas = res;
        this.loadingDeliveryAreas = false;
      },
      (err) => {
        this.loadingDeliveryAreas = false;
      },
    );
  }

  getDefaultSlots(showLoading = true) {
    setTimeout(() => (this.loadingDefaultSlots = showLoading));
    this.collectionsService.getDefaultSlots(this.partnerID, this.isWorkshop ? "WORKSHOP": this.isRentals ? "RENTALS" : "").subscribe(
      (res) => {
        console.log(res);
        this.defaultSlots = res;
        this.loadingDefaultSlots = false;
      },
      (err) => {
        this.loadingDefaultSlots = false;
      },
    );
  }

  getOverrideSlots(showLoading = true) {
    setTimeout(() => (this.loadingOverrideSlots = showLoading));
    this.collectionsService.getOverrideSlots(this.partnerID, this.isWorkshop ? "WORKSHOP": this.isRentals ? "RENTALS" : "").subscribe(
      (res) => {
        console.log(res);
        this.overrideSlots = res;
        this.loadingOverrideSlots = false;
      },
      (err) => {
        this.loadingOverrideSlots = false;
      },
    );
  }

  getUnavailableDates(showLoading = true) {
    setTimeout(() => (this.loadingUnavailableDates = showLoading));
    this.collectionsService.getUnavailableDates(this.partnerID).subscribe(
      (res) => {
        console.log(res);
        this.unavailableDates = res;
        this.loadingUnavailableDates = false;
      },
      (err) => {
        this.loadingUnavailableDates = false;
      },
    );
  }

  vehicleChanged() {
    this.getVehicleList();
    this.getDefaultSlots();
    this.getUnavailableDates();
    this.getOverrideSlots();
  }

  areaChanged() {
    this.getDeliveryAreas();
    this.getDefaultSlots();
    this.getUnavailableDates();
    this.getOverrideSlots();
  }

  addNew(type) {
    switch (type) {
      case 'Vehicle':
        this.panelData = {
          linkedPartners: [{ partnerID: this.helpersService.getPartnerId() }],
        };
        this.showVehicleConfig = true;
        break;
      case 'CutOffRule':
        this.panelData = {
          linkedPartners: [],
          bufferDays: 1,
          cutOffTime: new Date('1970-01-01 17:00:00'),
        };
        this.showCutOffTimeConfig = true;
        break;
      case 'Area':
        this.panelData = {
          linkedPartners: [{ partnerID: this.helpersService.getPartnerId() }],
        };
        this.showDeliveryAreaConfig = true;
        break;
      case 'Slot':
        this.panelData = {
          linkedPartners: [{ partnerID: this.helpersService.getPartnerId() }],
          canDoCollection: true,
          canDoDelivery: true,
          slotStartTime: new Date('1970-01-01 09:00:00'),
          slotEndTime: new Date('1970-01-01 12:00:00'),
          bufferDays: 1,
          cutOffTime: new Date('1970-01-01 17:00:00'),
        };
        this.showDefaultSlotsConfig = true;
        break;
      case 'UnavailableDate':
        this.panelData = {
          linkedPartners: [{ partnerID: this.helpersService.getPartnerId() }],
          startTime: new Date('1970-01-01 07:00:00'),
          endTime: new Date('1970-01-01 18:00:00'),
        };
        this.showUnavailableDatesConfig = true;
        break;
      case 'OverrideSlot':
        this.panelData = {
          linkedPartners: [{ partnerID: this.helpersService.getPartnerId() }],
          slotStartTime: new Date('1970-01-01 09:00:00'),
          slotEndTime: new Date('1970-01-01 12:00:00'),
          bufferDays: 1,
          cutOffTime: new Date('1970-01-01 17:00:00'),
        };
        this.showOverrideSlotsConfig = true;
        break;
    }
  }

  deleteRecord(item, type) {
    switch (type) {
      case 'Vehicle':
        this.confirmationService.confirm({
          key: 'delete_item',
          header: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_item',
          ),
          message: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_vehicle',
            { itemName: item.name },
          ),
          accept: () => {
            this.loadingVehicleList = true;
            this.collectionsService
              .deleteVehicle(this.helpersService.getPartnerId(), item.id)
              .subscribe(
                (res) => {
                  this.vehicleChanged();
                },
                (err) => {
                  this.loadingVehicleList = false;
                },
              );
          },
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
        });
        break;
      // case 'CutOffRule':
      //   this.confirmationService.confirm({
      //     key: "delete_item", header: this.translate.instant("bikeshop.shop_profile.collections.delete_item"), message: this.translate.instant("bikeshop.shop_profile.collections.delete_cut_off"), accept: () => {
      //       this.loadingCutOffRules = true;
      //       this.collectionsService.deleteCutOffRule(this.helpersService.getPartnerId(), item.id).subscribe(res => {
      //         this.getCutOffRules();
      //       }, err => {
      //         this.loadingCutOffRules = false;
      //       })
      //     }, acceptLabel: this.translate.instant("general.yes"), rejectLabel: this.translate.instant("general.no")
      //   });
      //   break;
      case 'Area':
        this.confirmationService.confirm({
          key: 'delete_item',
          header: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_item',
          ),
          message: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_area',
          ),
          accept: () => {
            this.loadingDeliveryAreas = true;
            this.collectionsService
              .deleteDeliveryAreas(this.helpersService.getPartnerId(), item.id)
              .subscribe(
                (res) => {
                  this.areaChanged();
                },
                (err) => {
                  this.loadingDeliveryAreas = false;
                },
              );
          },
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
        });
        break;
      case 'Slot':
        this.confirmationService.confirm({
          key: 'delete_item',
          header: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_item',
          ),
          message: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_slot',
          ),
          accept: () => {
            this.loadingDefaultSlots = true;
            this.collectionsService
              .deleteDefaultSlots(this.helpersService.getPartnerId(), item.id)
              .subscribe(
                (res) => {
                  this.getDefaultSlots();
                },
                (err) => {
                  this.loadingDefaultSlots = false;
                },
              );
          },
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
        });
        break;
      case 'UnavailableDate':
        this.confirmationService.confirm({
          key: 'delete_item',
          header: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_item',
          ),
          message: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_unavailable_date',
          ),
          accept: () => {
            this.loadingUnavailableDates = true;
            this.collectionsService
              .deleteUnavailableDate(
                this.helpersService.getPartnerId(),
                item.id,
              )
              .subscribe(
                (res) => {
                  this.getUnavailableDates();
                },
                (err) => {
                  this.loadingUnavailableDates = false;
                },
              );
          },
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
        });
        break;
      case 'OverrideSlot':
        this.confirmationService.confirm({
          key: 'delete_item',
          header: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_item',
          ),
          message: this.translate.instant(
            'bikeshop.shop_profile.collections.delete_override_slot',
          ),
          accept: () => {
            this.loadingOverrideSlots = true;
            this.collectionsService
              .deleteOverrideSlot(this.helpersService.getPartnerId(), item.id)
              .subscribe(
                (res) => {
                  this.getOverrideSlots();
                },
                (err) => {
                  this.loadingOverrideSlots = false;
                },
              );
          },
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
        });
        break;
    }
  }

  editRecord(item, type) {
    this.panelData = JSON.parse(JSON.stringify(item));
    switch (type) {
      case 'Vehicle':
        this.showVehicleConfig = true;
        break;
      case 'CutOffRule':
        this.panelData.cutOffTime = new Date('1970-01-01T' + item.cutOffTime);
        this.showCutOffTimeConfig = true;
        break;
      case 'Area':
        this.showDeliveryAreaConfig = true;
        break;
      case 'Slot':
        this.panelData.slotStartTime = new Date(
          '1970-01-01T' + item.slotStartTime,
        );
        this.panelData.slotEndTime = new Date('1970-01-01T' + item.slotEndTime);
        this.panelData.cutOffTime = new Date('1970-01-01T' + item.cutOffTime);
        this.showDefaultSlotsConfig = true;
        break;
      case 'UnavailableDate':
        this.panelData.date = new Date(item.date);
        this.panelData.startTime = new Date('1970-01-01T' + item.startTime);
        this.panelData.endTime = new Date('1970-01-01T' + item.endTime);
        this.showUnavailableDatesConfig = true;
        break;
      case 'OverrideSlot':
        this.panelData.date = new Date(item.date);
        this.panelData.cutOffTime = new Date('1970-01-01T' + item.cutOffTime);
        this.panelData.slotStartTime = new Date(
          '1970-01-01T' + item.slotStartTime,
        );
        this.panelData.slotEndTime = new Date('1970-01-01T' + item.slotEndTime);
        this.showOverrideSlotsConfig = true;
        break;
    }
  }

  dayOfWeek(val) {
    switch (val) {
      case 0:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.sunday',
        );
      case 1:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.monday',
        );
      case 2:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.tuesday',
        );
      case 3:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.wednesday',
        );
      case 4:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.thursday',
        );
      case 5:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.friday',
        );
      case 6:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.saturday',
        );
    }
  }

  close() {
    this.showVehicleConfig = false;
    this.showCutOffTimeConfig = false;
    this.showDeliveryAreaConfig = false;
    this.showDefaultSlotsConfig = false;
    this.showUnavailableDatesConfig = false;
    this.showOverrideSlotsConfig = false;
  }

  isStoreInList(list) {
    return (
      list
        .map((x) => {
          return x.partnerID;
        })
        .indexOf(this.helpersService.getPartnerId()) > -1
    );
  }

  canAddVehicle() {
    return this.deliveryAreas.length > 0;
  }

  canAddSlots() {
    return this.vehicleList.length > 0;
  }

  canAddOverrideSlots() {
    return this.vehicleList.length > 0;
  }

  updatePartnerMasterConfig(partner) {
    const data = {
      partnerID: partner.partnerID,
      collectionEnabled: partner.collectionsEnabled,
      deliveryEnabled: partner.deliveriesEnabled,
    };
    this.collectionsService.updatePartnerMasterConfig(data).subscribe((res) => {
      this.getLinkedEnabledPartners();
      this.getVehicleList(false);
      this.getDeliveryAreas(false);
      this.getDefaultSlots(false);
    });
  }

  updateRentalsConfig(partner){
    const data = {
      partnerID: partner.partnerID,
      collectionEnabled: partner.collectionsEnabled,
      deliveryEnabled: partner.deliveriesEnabled,
      minimumRentalDaysForCollection : partner.minimumRentalDaysForCollection
    };
    this.collectionsService.updateRentalsConfig(data).subscribe((res) => {
      this.getLinkedEnabledPartners();
      this.getVehicleList(false);
      this.getDeliveryAreas(false);
      this.getDefaultSlots(false);
    });
  }

  canConfigureStores() {
    return (
      this.allLinkedPartners &&
      this.allLinkedPartners.length > 0 &&
      this.allLinkedPartners.filter((x) => {
        return x.collectionsEnabled || x.deliveriesEnabled;
      }).length > 0
    );
  }

  getPartnerName(id) {
    return this.allLinkedPartners
      .filter((x) => {
        return x.partnerID === id;
      })
      .pop().partnerName;
  }

  formatCutOffTime(val) {
    return moment(val).format('h:mm A');
  }

  getBufferDay(dayOfWeek, buffer) {
    var diff = dayOfWeek - buffer;
    return diff < 0 ? 7 + diff : diff;
  }

  getBufferDate(date, buffer) {
    return moment(date)
      .add(-1 * buffer, 'day')
      .format(this.countryData.MomentDateFormat);
  }
}
